import React from "react";
import { FaAward } from 'react-icons/fa';
import PageHeaderContent from "../../components/pageHeaderContent";
// import {
//   VerticalTimeline,
//   VerticalTimelineElement,
// } from "react-vertical-timeline-component";
// import { data } from "./utils";
import "react-vertical-timeline-component/style.min.css";
import "./style.scss";
// import { MdWork, MdSchool } from "react-icons/md";
import certificateImage from "../../images/Other/certificate.png";
import python1 from "../../images/certificates/python_1.png"
import python2 from "../../images/certificates/python_2.png"
import python3 from "../../images/certificates/python_3.png"
import python4 from "../../images/certificates/python_4.png"
import python5 from "../../images/certificates/python_5.png"
import rpa1 from "../../images/certificates/RPA_1.png"
import rpa2 from "../../images/certificates/RPA_2.png"
import databricks from "../../images/certificates/databricks_1.png"
import googleData1 from "../../images/certificates/google_data_analytics_1.png"

const CertificateImage = () => {
  return (
    
    <img
      src={certificateImage}
      alt="certificateImage"
      title="certificate"
    />
    
  );
};

const Certifications = () => {
  return (
    <section id="certifications" className="certifications">
      <PageHeaderContent
        headerText="Certifications"
        img={<CertificateImage />}
        icon={<FaAward size={40} />}
      />
   
      <div className="certificate">
        <div className="certificate_single">
          <a href="https://coursera.org/verify/specialization/HG4EN8V3XGW1">
            <img className="certificate_single_img" src={python4} alt="python Certificate" />
          </a>
        </div>
        <div className="certificate_single">
          <a href="https://coursera.org/verify/IXJSF1FNRJWJ">
            <img className="certificate_single_img" src={python5} alt="python Certificate" />
          </a>
        </div>
        <div className="certificate_single">
           <a href="https://www.coursera.org/account/accomplishments/verify/HJ98VFP9R448">
            <img className="certificate_single_img" src={python3} alt="python Certificate" />
          </a>
        </div>
        <div className="certificateImgs_single">
          <a href="https://www.coursera.org/account/accomplishments/verify/IXJSF1FNRJWJ">
            <img className="certificate_single_img" src={python2} alt="python Certificate" />
          </a>
        </div>
        <div className="certificateImgs_single">
          <a href="https://www.coursera.org/account/accomplishments/verify/O9ARZX1XLDLZ">
            <img className="certificate_single_img" src={python1} alt="python Certificate" />
          </a>
        </div>
        <div className="certificateImgs_single">
          <a href="https://www.coursera.org/account/accomplishments/records/0D2NKBIWLNNF">
            <img className="certificate_single_img" src={rpa1} alt="rpa Certificate" />
          </a>
        </div>
        <div className="certificateImgs_single">
          <a href="https://www.coursera.org/account/accomplishments/records/UK7VW9ZFBRMU">
            <img className="certificate_single_img" src={rpa2} alt="rpa Certificate" />
          </a>
        </div>
        <div className="certificateImgs_single">
          <a href="https://www.coursera.org/account/accomplishments/verify/H6X4EXXMHS9W">
            <img className="certificate_single_img" src={googleData1} alt="google data analytics Certificate" />
          </a>
        </div>
        <div className="certificateImgs_single">
            <img className="certificate_single_img" src={databricks} alt="databricks Certificate" />
        </div>
      </div>
      
    </section>
  );
};

export default Certifications;
